var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80.392,
    height: 80.392,
    viewBox: "0 0 80.392 80.392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M80.3916 5.02448C80.3916 22.8614 67.1081 37.6051 49.8993 39.8818C48.7845 31.4972 45.0947 23.9291 39.6462 18.0096C45.6599 7.26979 57.1534 0 70.3426 0C70.3426 0 75.3671 0 75.3671 0C78.1463 0 80.3916 2.24531 80.3916 5.02448C80.3916 5.02448 80.3916 5.02448 80.3916 5.02448ZM0 15.0735C0 12.2944 2.24531 10.0491 5.02448 10.0491C5.02448 10.0491 10.049 10.0491 10.049 10.0491C29.4717 10.0491 45.2203 25.7977 45.2203 45.2204C45.2203 45.2204 45.2203 50.2449 45.2203 50.2449C45.2203 50.2449 45.2203 75.3672 45.2203 75.3672C45.2203 78.1464 42.975 80.3917 40.1958 80.3917C37.4166 80.3917 35.1713 78.1464 35.1713 75.3672C35.1713 75.3672 35.1713 50.2449 35.1713 50.2449C15.7486 50.2449 0 34.4963 0 15.0735C0 15.0735 0 15.0735 0 15.0735Z",
    fill: "#6C8665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/Shape 3.2530dc191b72b5b2ff59c8ee0413f421.svg";
export { ForwardRef as ReactComponent };